<template>
  <div @add-slot="onClickChild">
      <slot></slot>
  </div>
</template>

<script>
  import VariableCountFormSection from './VariableCountFormSection.vue'
	export default {
		name: "RevealClick",
    components: {
      VariableCountFormSection,
    },
    props: {
      actualCount: {default: 0},
    },
    data() {
      return {
        currentCount: this.actualCount
      }
    },
    methods: {
      revealItem() {
        this.currentCount = this.actualCount
        if(this.actualCount === 0) {
          this.currentCount = 1
        }
      },
      hideItem() {
        this.currentCount--
      },
      onClickChild(value) {
        this.currentCount = value
      }
    },
	}
</script>